let Being = require('./beings');

function Country (name) {

  this.name = name;
  this.latestResults = {
    relativeStrength: 0,
    capturedLand: 0,
    capturedFood: 0,
    casualties: 0
  };
  this.males = [];
  this.females = [];
  this.homeMilitary = 1;
  this.bonuses = {
    techResearch: 1,
    domResearch: 1,
    milResearch: 1,
    milFunding: 1,
    domFunding: 1,
    birthing: 1,
    developLand: 0,
    production: 1,
    defenses: 1,
    soldiersTrained: 1,
    militia: 1,
  };
  this.population = 0;
  this.generation = 0;
  this.workers = 20;
  this.soldiers = 0;
  this.educators = 0;
  this.militaryTech = 1;
  this.domesticTech = 1;
  this.educatorBonus = 1;
  this.morale = 1;
  this.numTargeted = 0;
  this.shadyTech = 1;
  this.ageProgress = 1;
  this.techPower = 1;
  this.size = 0;
  this.climate = 0;
  this.lost = false;
  this.diseaseRate = 0;
  this.farmableLand = 0;
  this.foodStorage = 0;
  this.warLevel = 0;
  this.events = {
    numCulled: 0,
    numBorn: 0,
    health: 0,
    oldAge: 0,
    starving: 0
  };
  this.messages = [];

  this.avgInt = 0;
  this.avgStr = 0;
  this.avgHealth = 0;
}

Country.prototype.setSize = function (maxSize) {
  this.size = maxSize * 0.6;
};

Country.prototype.setPerk = function (perk) {
  if (perk === 'str') {
    this.males.forEach(male => {
      male.str *= 1.25;
    });
    this.females.forEach(female => {
      female.str *= 1.25;
    });
  } else if (perk === 'int') {
    this.males.forEach(male => {
      male.int *= 1.25;
    });
    this.females.forEach(female => {
      female.int *= 1.25;
    });
  } else if (perk === 'average') {
    this.males.forEach(male => {
      male.int *= 1.12;
      male.str *= 1.12;
    });
    this.females.forEach(female => {
      female.int *= 1.12;
      female.str *= 1.12;
    });
  }
};

Country.prototype.setClimate = function (minTemp, maxTemp) {
  this.climate = minTemp + Math.random() * (maxTemp - minTemp);
};

Country.prototype.setEnvironment = function (farmableLandPercentage) {
  //farmableLand function of random percentage of total land and climate
  this.farmableLand = this.size * (farmableLandPercentage / 100) *
    (this.climate / 100);
};

Country.prototype.setDisease = function (world) {
  let worldTemp = 0;
  world.countries.forEach(country => {
    worldTemp += country.climate;
  });
  let avgTemp = worldTemp / world.countries.length;
  // Disease rate determined by relative climate to world climate and
  // population density
  this.diseaseRate = Math.pow((this.climate / avgTemp),2) * (this.population / this.size);
};

Country.prototype.generateFood = function () {
  let foodProduced = 0;
  let workers = this.males.concat(this.females);
  for (let i = 0; i < (this.workers +
    (Math.floor(this.soldiers * 0.5) * this.homeMilitary) - 1); i++) {
      if (workers[i % workers.length]){
        foodProduced += workers[i % workers.length].harvestFood();
      }
  }
  foodProduced *= Math.min(this.domesticTech,2) * this.bonuses.production;
  // Food storage capacity increased by country intelligence
  let moddedFarmableLand = this.farmableLand * (this.avgInt / 100);
  this.foodStorage += foodProduced > moddedFarmableLand ?
    moddedFarmableLand : foodProduced;
};

Country.prototype.allocateBeings = function (options) {
  this.workers = Math.floor(this.population * (options.workerPercentage / 100));
  this.soldiers = Math.floor(this.population * (options.militaryPercentage / 100));
  this.educators = Math.floor(this.population * (options.educatorPercentage / 100));
};

Country.prototype.techUp = function (num) {
  this.techPower = (1 + num);
};

Country.prototype.setMorale = function () {
  this.morale = this.techPower;
};

Country.prototype.learnTech = function (modifiers = {mil: 1, dom: 1, shady: 1, age: 1}) {
  this.bonuses = modifiers;
  this.educatorBonus = (1 + this.educators/this.population);
  this.militaryTech *= Math.min((modifiers.milResearch * modifiers.domFunding * this.educatorBonus),2);
  this.domesticTech *= Math.min((modifiers.domResearch * this.educatorBonus),2);
  this.ageProgress *= Math.min((modifiers.techResearch * modifiers.domFunding * this.educatorBonus),2);
};

Country.prototype.assessDamages = function (results) {
  let casualties, capturedFood, capturedLand;
  if (results.aggressor.object === this) {
    casualties = results.attackerCasualties;
    capturedFood = results.capturedFood;
    capturedLand = results.capturedLand;
    this.morale *= results.relativeStrength > 1 ? 1.2 : 0.8;
  } else {
    casualties = results.defenderCasualties;
    capturedFood = -results.capturedFood;
    capturedLand = -results.capturedLand;
    this.morale *= results.relativeStrength > 1 ? 0.8 : 1.2;

  }

  for (let i = 0; i < casualties / 2; i++) {
    if (this.males[i]) this.males[i].alive = false;
    if (this.females[i]) this.females[i].alive = false;
  }

  this.latestResults.relativeStrength = results.relativeStrength;
  this.latestResults.casualties += casualties;
  this.latestResults.capturedFood += capturedFood;
  this.latestResults.capturedLand += capturedLand/this.size;
  this.foodStorage += capturedFood;
  if (this.size + capturedLand < 400) {
    this.loseGame();
  } else {
    this.size += capturedLand;
  }
  this.farmableLand += (results.capturedLand * 0.5);
};

Country.prototype.sendMilitary = function () {
  this.homeMilitary = 0;
};

Country.prototype.returnMilitary = function () {
  this.homeMilitary = 1;
};

Country.prototype.handleFood = function () {
  let population = this.males.concat(this.females);
  // Sort population by strongest (in strenght and intelligence) to weakest
  let sortedBeings = population.sort((b,a) => {
    return (a.str + a.int) - (b.str + b.int);
  });
  let self = this;
  // Strongest eat first
  sortedBeings.forEach(being => {
    if (self.foodStorage > 0) {
      self.foodStorage -= being.age < 5 ? 0.75 : (being.age < 10 ? 1 : 1.5);
      being.daysStarving = 0;
      being.health += 1;
    } else {
      // Consequences of not eating
      being.daysStarving += 1;
      being.health -= 5;
    }
  });
};

Country.prototype.setupCountry = function (world) {
  this.getInfo();
  this.setDisease(world);
  this.generateFood();
};

Country.prototype.cullWeak = function () {
  let that = this;
  let pop = this.males.concat(this.females).filter(human => {
    return human.age > 10;
  });
  let ordered = pop.sort((a,b) => {
    return a.str - b.str;
  });
  // After ordering population by str, set weakest to not alive.
  // This percentage is affected by a modifier, determined by country Int.
  let modifier = this.domesticTech * this.morale * 10;
  let weakest = ordered.slice(0,Math.ceil(pop.length / modifier));
  weakest.forEach(being => {
    being.alive = false;
    that.events.numCulled += 1;
    that.population -= 1;
  });

  this.cleanseDead();
};

Country.prototype.loseGame = function () {
  this.lost = true;
};

Country.prototype.targeted = function () {
  this.numTargeted += 1;
};

Country.prototype.initiateBirthing = function () {
  // Order males and females by 'attractiveness' and filter by acceptable
  // birthing age.
  let sortedMales = this.males.sort((b,a) => {
    return (a.str + a.int + a.health) - (b.str + b.int + b.health);
  });

  let sortedFemales = this.females.sort((b,a) => {
    return (a.str + a.int + a.health) - (b.str + b.int + b.health);
  });

  // Breed available males with available females within similar attractiveness
  // range.
  if (sortedMales.length > 0 && sortedFemales.length > 0) {
    const smallestGroupSize = sortedMales.length < sortedFemales.length ?
      sortedMales.length : sortedFemales.length;
    for (let i = 0; i < smallestGroupSize; i++) {
      let newBeing = sortedMales[i].breedWith(sortedFemales[i]);
      if (newBeing.hasOwnProperty('alive')) {
        sortedMales[i].offspring.push(newBeing);
        sortedFemales[i].offspring.push(newBeing);
        if (newBeing.gender === 'male') {
          this.males.push(newBeing);
        } else {
          this.females.push(newBeing);
        }
        this.events.numBorn += 1;
      }
    }
    if (this.bonuses.birthing > 1) {
      for (let i = 0; i < (smallestGroupSize * (this.bonuses.birthing - 1)); i++) {
        let newBeing = sortedMales[i].breedWith(sortedFemales[i]);
        if (newBeing.hasOwnProperty('alive')) {
          sortedMales[i].offspring.push(newBeing);
          sortedFemales[i].offspring.push(newBeing);
          if (newBeing.gender === 'male') {
            this.males.push(newBeing);
          } else {
            this.females.push(newBeing);
          }
          this.events.numBorn += 1;
        }
      }
    }
  }
};

Country.prototype.cleanseDead = function () {
  // Search through population for beings with a false alive attribute, and
  // and remove them from population array
  this.males = this.males.filter(male => {
    return male.alive === true;
  });

  this.females = this.females.filter(female => {
    return female.alive === true;
  });
};

Country.prototype.getInfo = function () {
  // Generational census
  let population = this.males.concat(this.females);

  this.avgInt = population.reduce((sum, el) => {
    return sum + el.int;
  },0)/population.length;

  this.avgStr = population.reduce((sum, el) => {
    return sum + el.str;
  },0)/population.length;

  this.avgHealth = population.reduce((sum, el) => {
    return sum + el.health;
  },0)/population.length;

  this.population = population.length;
};

Country.prototype.developLand = function () {
  let toDevelop = (this.size - this.farmableLand) * this.bonuses.developLand;
  this.farmableLand += toDevelop;
};

Country.prototype.updateCycle = function (world) {
  // Invoke every cycle: disease handling, citizen updates, culling of the weak,
  // food management.
  this.setDisease(world);
  let population = this.males.concat(this.females);
  let self = this;
  population.forEach(being => {
    being.updateCycle(self.avgInt, self.diseaseRate);
  });
  // Every cycle, cull about 5% of the population, affected by intMod
  this.cullWeak();

  if (world.cycle % 5 === 0) {
    // Beings give birth twice a generation
    this.initiateBirthing();
  }
  this.generateFood();
  this.handleFood();
};

Country.prototype.printEvents = function (world, humanPlayer) {
  humanPlayer.setEvents(this,this.events);

  let events = this.events;
  console.log(this);

  this.events = {
    numCulled: 0,
    numBorn: 0,
    health: 0,
    oldAge: 0,
    starving: 0
  };

  this.latestResults = {
    relativeStrength: 0,
    capturedLand: 0,
    capturedFood: 0,
    casualties: 0
  };

  this.messages = [];
};

Country.prototype.updateGen = function (world,humanPlayer) {
  // Updates that occur generationally.
  this.developLand();
  this.setMorale();
  this.getInfo();
  this.cleanseDead();
  this.printEvents(world, humanPlayer);
  this.farmableLand = this.farmableLand > this.size ? this.size : this.farmableLand;
  this.numTargeted = 0;
  this.generation += 1;
  if (this.population < 10) {
    this.loseGame();
  }
};

module.exports = Country;



/*****************
 ** WEBPACK FOOTER
 ** ./game/game_logic/countries.js
 ** module id = 13
 ** module chunks = 0
 **/